import { render, staticRenderFns } from "./AddSidedish.vue?vue&type=template&id=87964934&"
import script from "./AddSidedish.vue?vue&type=script&lang=js&"
export * from "./AddSidedish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports